import React from "react";

import styles from "./DatesRow.style";
import { Div, Text } from "@vkontakte/vkui";
import { selectDay } from "../../../redux/actions/datesActions";
import { connect } from "react-redux";

const DatesRow = ({ dates, availableDates, selectDay, selectedDay }) => {
  
  const getDatesRow = (dates) => {
    return dates.map(mapDaysToButtons);
  };

  const mapDaysToButtons = (day, index) => {
    if (!day) {
      return (
        <Div
          style={{
            ...styles.button,
          }}
          key={`day-${index}`}
        />
      );
    }
    const isDayAvailable = getDateAvailability(day);
    const isDaySelected = getDaySelectivity(day);

    if (isDayAvailable && !isDaySelected) {
      return (
        <Div
          onClick={() => selectDay(day)}
          key={`day-${index}`}
          style={{
            ...styles.button,
            ...styles.availableButton,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text
            weight={"regular"}
            style={styles.textDay}
          >
            {day ? day.getDate() : null}
          </Text>
        </Div>
      );
    } else if (isDayAvailable && isDaySelected) {
      return (
        <Div
          key={`day-${index}`}
          style={{
            ...styles.button,
            ...styles.selectedButton,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text
            weight={"regular"}
            style={styles.textDay}
          >
            {day ? day.getDate() : null}
          </Text>
        </Div>
      );
    } else {
      return (
        <Div
          key={`day-${index}`}
          style={{
            ...styles.button,
            ...styles.unAvailableButton,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text
            weight={"regular"}
            style={styles.textDay}
          >
            {day ? day.getDate() : null}
          </Text>
        </Div>
      );
    }
  };

  const getDaySelectivity = (day) => {
    if (day && selectedDay) {
      return day.getDate() === selectedDay.getDate();
    } else {
      return false;
    }
  };

  const getDateAvailability = (date) => {
    if (date) {
      for (let i = 0; i < availableDates.length; i++) {
        if (availableDates[i].getDate() === date.getDate()) {
          return true;
        }
      }
      return false;
    }
  };

  return (
    <Div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "0",
        marginTop: "12px",
      }}
    >
      {getDatesRow(dates)}
    </Div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedDay: state.dates.selectedDay,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectDay: (day) => dispatch(selectDay(day)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DatesRow);
